import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Header from "../../components/Header/Header";
import TransactionTable from "../../components/ReportsTable/MF/MFReportsTable";
import DateRangePickerFree from "../../components/DatePicker/DateRangePickerFree";
import { useDispatch } from "react-redux";
import { SelectChangeEvent } from "@mui/material";
import { getMF } from "../../redux/mf/mfSlice";

const MFTransactions: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [dropdownValues, setDropdownValues] = useState<any>({
    startDate: undefined,
    endDate: undefined,
  });
  const dispatch = useDispatch<any>();

  const [selectedFundType, setSelectedFundType] = useState<string>("");
  const [mfData, setMfData] = useState<any[]>([]);
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const handleSearch = async () => {
    if (dropdownValues.startDate && dropdownValues.endDate) {
      const startDate = dropdownValues.startDate;
      const endDate = dropdownValues.endDate;

      try {
        const payload = {
          startDate,
          endDate,
          fundType: selectedFundType,
        };

        const response = await dispatch(getMF(payload));
        setIsSearched(true);
        if (response.payload && response.payload.data) {
          setMfData(response.payload.data);
        } else {
          console.error("Invalid response structure", response);
        }
      } catch (error) {
        console.error("Failed to load user", error);
        setIsSearched(true);
      }
    }
  };

  const handleFundTypeChange = (event: SelectChangeEvent<string>) => {
    setSelectedFundType(event.target.value);
  };

  return (
    <div className="min-h-screen bg-lightBg py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-primary mb-2 font-nunito">
              MF Transactions
            </h1>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md mb-8">
          <div className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4 items-end">
            <DateRangePickerFree
              open={open}
              setOpen={setOpen}
              setTimestamps={setDropdownValues}
              timestamps={dropdownValues}
            />
            <FormControl className="w-full md:w-1/4">
              <Select
                labelId="fund-type-label"
                id="fund-type-select"
                value={selectedFundType}
                onChange={handleFundTypeChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  <em>Select Fund Type</em>
                </MenuItem>
                <MenuItem value="DEBT">Debt</MenuItem>
                <MenuItem value="EQUITY">Equity</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              className="w-full md:w-auto px-6"
            >
              Search
            </Button>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          {isSearched && mfData.length === 0 ? (
            <Typography align="center">
              No transactions found for the selected criteria.
            </Typography>
          ) : (
            <TransactionTable
              mfData={mfData}
              startDate={dropdownValues.startDate || null}
              endDate={dropdownValues.endDate || null}
              fundType={selectedFundType}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MFTransactions;
